import { Backdrop, Button, Card, CardContent, CircularProgress, Dialog, DialogActions, DialogContent, DialogTitle, Typography } from "@mui/material";
import { enqueueSnackbar } from "notistack";
import { useEffect, useState } from "react";
import { Col, Row } from "react-bootstrap";
import { useForm } from "react-hook-form";
import { useSelector } from "react-redux";
import { useDispatch } from "react-redux";
import { FormTextField } from '@/shared/components/form/material-controls/TextField';
import StakeholderCountry from "../stakeholderInformation/stakeholderCountry";
import { addLocationMetadata, updateLocation, cleanup } from "../../../../../../../reducers/supplier/locations/updateLocation/updateLocationAction";

const EditLocationModal = ({ assetId, countries, open, onHideModal, onLocationUpdated, location }) => {
    const dispatch = useDispatch();
  
    const { 
      isUpdatingLocation, updateLocationError, updatedLocation
    } = useSelector(({ updateLocation }) => updateLocation);

    useEffect(() => {
      return () => {
        dispatch(cleanup());
      }
    }, [dispatch]);
  
    const { handleSubmit, reset, control, setValue, getValues, watch } = useForm();
      
    
  
    const handleClose = (event, reason) => {
      if (reason && reason === "backdropClick") 
          return;

      reset();
      onHideModal();
    }
  
    useEffect(() => {
      if(updateLocationError){
        enqueueSnackbar(updateLocationError, {variant: "error"});
      }
    }, [updateLocationError]);
  
    const onSubmit = (data) => {
      const finalData = {
        assetUpdate: {
          id: location.id,
          name: data.name,
          description: data.description,
          assetTypeId: "63ea1fb41600303865474038"
        },
        assetMetadata: {
          assetId: location.id,
          source: "locationInformation",
          metadata: {
            address: data.address,
            city: data.city,
            country: data.country,
            nationalRegion: data.nationalRegion,
            district: data.district,
            zipCode: data.zipCode,
            location: data.location,
            siteCode: data.siteCode,
            dictionaryCountryId: data.dictionaryCountryId,
            countryCode: data.countryCode,
            regionCode: data.regionCode,
            subRegionCode: data.subRegionCode, 
            intermediateRegionCode: data.intermediateRegionCode
          }
        }
      };

      dispatch(updateLocation(finalData));      
    }
  
    useEffect(() => {
      if(updatedLocation){
        enqueueSnackbar("Location updated successfully", {variant: "success"});
        handleClose();
        onLocationUpdated();
      }
    }, [updatedLocation]);
  
    return (
      <Dialog
          fullWidth={true}
          maxWidth='lg'
          scroll='paper'
          open={open}
          onClose={handleClose}
      >
          <DialogTitle>Edit Location</DialogTitle>
          <DialogContent>
                <Row>
                  <Col md={12}>
                    <FormTextField
                        name='name'
                        label='Name'
                        control={control}
                        rules={{ required: 'This field is required' }}
                        defaultValue={location.name}
                    />
                  </Col>
                  <Col md={12}>
                    <FormTextField
                        name='description'
                        label='Description'
                        control={control}
                        defaultValue={location.description}
                    />
                  </Col>
                  <Col md={12}>
                    <FormTextField
                        name='address'
                        label='Address'
                        control={control}
                        defaultValue={location.metadata.locationinformation.address}
                    />
                  </Col>
                  <Col md={6}>
                    <FormTextField
                        name='city'
                        label='City'
                        control={control}
                        defaultValue={location.metadata.locationinformation.city}
                    />
                  </Col>
                  <Col md={6}>
                    <FormTextField
                        name='country'
                        label='Country'
                        control={control}
                        defaultValue={location.metadata.locationinformation.country}
                    />
                  </Col>
                  <Col md={6}>
                    <FormTextField
                        name='nationalRegion'
                        label='National Region'
                        control={control}
                        defaultValue={location.metadata.locationinformation.nationalRegion}
                    />
                  </Col>
                  <Col md={6}>
                    <FormTextField
                        name='district'
                        label='District'
                        control={control}
                        defaultValue={location.metadata.locationinformation.district}
                    />
                  </Col>
                  <Col md={6}>
                    <FormTextField
                        name='zipCode'
                        label='Zip Code'
                        control={control}
                        defaultValue={location.metadata.locationinformation.zipCode}
                    />
                  </Col>
                  <Col md={6}>
                    <FormTextField
                        name='siteCode'
                        label='Site Code'
                        control={control}
                        defaultValue={location.metadata.locationinformation.siteCode}
                    />
                  </Col>
                  <Col md={12}>
                    <FormTextField
                        name='location'
                        label='Location'
                        control={control}
                        defaultValue={location.metadata.locationinformation.location}
                    />
                  </Col>
                  <StakeholderCountry 
                      control={control}
                      countries={countries}
                      watch={watch}
                      setValue={setValue}
                      stakeholderInfo={location.metadata.locationinformation}
                  />
                </Row>
          </DialogContent>
          <DialogActions>
              <Button onClick={handleClose}>Cancel</Button>
              <Button variant='contained' onClick={handleSubmit(onSubmit)}>Update</Button>
          </DialogActions>
  
          <Backdrop
            sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }}
            open={isUpdatingLocation}
          >
            <CircularProgress color="inherit" />
          </Backdrop>
      </Dialog>
    );
  }
  
  export default EditLocationModal;